// @flow

// Libs
import React from 'react'

// Styles
import { primary } from 'fc-styles/src/colors'

// Components
import CheckedBox from 'fc-icons/src/CheckedBox'

export default <CheckedBox color={primary()} size={20} />
